<div class="relative flex h-full w-full flex-col overflow-hidden">
    <div
        class="bg-slate-800/60 sticky top-0 z-50 flex w-full justify-end px-3 py-2"
    >
        @if (src) {
            <button
                (click)="download()"
                class="btn btn-sm btn-white flex items-center gap-2 border border-slate-200 shadow-sm"
            >
                <span class="hidden sm:inline">{{
                    'translate_download' | translate
                }}</span>
                <i class="fa-light fa-download"></i>
            </button>
        }
    </div>

    <div
        class="flex min-h-0 flex-1 items-center justify-center overflow-auto p-4"
    >
        @if (safeSrc && isImage) {
            <img
                [src]="safeSrc"
                [alt]="fileName"
                class="max-h-[75vh] max-w-full object-contain"
            />
        }
        <!-- Angular refuses to bind `sandbox` on an iframe: it blanks the
             element and drops it from the DOM (NG0910). The two cases must
             therefore be separate elements with static attributes. -->
        @if (safeSrc && !isImage) {
            @if (isPdf) {
                <!-- No sandbox: Chrome's built-in viewer needs scripts to
                     render a PDF, and a verified application/pdf cannot
                     carry markup that runs in this origin. -->
                <iframe
                    [src]="safeSrc"
                    class="h-full min-h-[75vh] w-full border-0"
                ></iframe>
            } @else {
                <!-- allow-same-origin is required because a blob: URL can
                     only be resolved by the origin that created it;
                     scripts stay blocked. -->
                <iframe
                    [src]="safeSrc"
                    sandbox="allow-same-origin"
                    class="h-full min-h-[75vh] w-full border-0"
                ></iframe>
            }
        }
    </div>
</div>
